import { memo, useCallback } from 'react';
import { Button, Input } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * Step 2 of the Remove flow: type the member's email; Remove from workspace is disabled until it
 * matches. Back returns to step 1.
 *
 * @param {object} props
 * @param {string} props.email The email the user has to type.
 * @param {string} props.value Typed text.
 * @param {boolean} props.isMatch
 * @param {boolean} props.isSubmitting
 * @param {(value: string) => void} props.onChange
 * @param {() => void} props.onBack
 * @param {() => void} props.onCancel Closes the dialog.
 * @param {() => void} props.onConfirm
 */
const RemoveMemberStep2 = ({ email, value, isMatch, isSubmitting, onChange, onBack, onCancel, onConfirm }) => {
  const { t } = useTranslation('people-access');
  const handleChange = useCallback((event) => onChange(event.target.value), [onChange]);
  return (
    <>
      <div className="px-6 py-4">
        <Input
          aria-label={t('removeFlow.emailLabel')}
          placeholder={t('removeFlow.emailPlaceholder', { email })}
          value={value}
          onChange={handleChange}
          disabled={isSubmitting}
          autoComplete="off"
          autoFocus
        />
      </div>
      <div className="flex justify-end gap-2 px-6 py-4">
        <Button variant="ghost" size="md" onClick={onBack} disabled={isSubmitting}>
          {t('removeFlow.back')}
        </Button>
        <Button variant="secondary" size="md" onClick={onCancel} disabled={isSubmitting}>
          {t('removeFlow.cancel')}
        </Button>
        <Button variant="danger" size="md" onClick={onConfirm} disabled={!isMatch} loading={isSubmitting}>
          {t('removeFlow.confirm')}
        </Button>
      </div>
    </>
  );
};

export default memo(RemoveMemberStep2);
